/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 800
// module chunks = 1